import { useCurrentUser } from '@framework/auth/state/AuthSlice.tsx';
import { SubmissionModuleState } from '@framework/common-web/frontoffice/module/fsm/SubmissionModuleState.ts';
import {
  type IModuleStateMachineRecord,
  ModuleStateMachine,
} from '@framework/frontoffice-submission/module/fsm/ModuleStateMachine.ts';
import { ActionMessage } from '@framework/frontoffice-submission/submission/signer/ActionMessage.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SubmissionModuleSigner } from '../../sign/SubmissionModuleSigner.tsx';

export interface ISIgnActionButtonsProps {
  data: IModuleStateMachineRecord;
}

export function SignActionButtons(props: ISIgnActionButtonsProps) {
  const { data } = props;

  const currentUser = useCurrentUser();
  const { t } = useTranslation();

  const canBeSigned = useMemo(() => {
    return ModuleStateMachine.canTransition(data, {
      from: SubmissionModuleState.Sign,
      to: SubmissionModuleState.Completed,
      user: currentUser,
    });
  }, [currentUser, data]);

  if (!canBeSigned.allowed && canBeSigned.message === 'no-action-permission') {
    return (
      <ActionMessage
        message={t(
          'submission-action-button.firma-delegata',
          'La firma è delegata ad un altro utente.',
        )}
        type="info"
      />
    );
  }

  if (!canBeSigned.allowed) return null;

  return (
    <SubmissionModuleSigner
      submission={data.submission}
      submissionModule={data.module}
    />
  );
}
